import React from 'react';
import { Info } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export const Note = () => {
  return <section className="py-12 md:py-16 bg-dark-card border-y border-white/5" data-id="element-129">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-130">
        <FadeIn data-id="element-131">
          <div className="bg-[#0a0a0a] border border-white/10 rounded-xl p-6 md:p-7 flex items-start gap-4" data-id="element-132">
            <div className="shrink-0 w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center" data-id="element-133">
              <Info className="w-5 h-5 text-gray-400" data-id="element-134" />
            </div>
            <div data-id="element-135">
              <p className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-2 font-sans" data-id="element-136">
                Nota importante
              </p>
              <p className="text-base md:text-lg text-gray-300 leading-relaxed font-sans m-0" data-id="element-137">
                Esta guía es{' '}
                <span className="text-white font-semibold" data-id="element-138">
                  educativa e informativa
                </span>
                . Los resultados dependen del esfuerzo, contexto y aplicación de
                cada persona. No es asesoría financiera ni garantiza ingresos
                específicos.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};